import clsx from 'clsx';

const COLORS = {
  DEFAULT_BORDER: '#596802',
  DEFAULT_BACKGROUND: '#ECED90',
  SELECTED_SHADOW: '#596802',
  DEFAULT_SHADOW: '#e2e2e2',
  ICON_COLOR: '#FF8989',
  TEXT_COLOR: '#596802'
};

const BASE_BUTTON_CLASSES = [
  'p-4',
  'w-full',
  'border',
  'text-left',
  'h-24',
  'flex',
  'items-center',
  'justify-between',
  'bg-white',
  'transition-all',
  'duration-200',
  'hover:opacity-90',
  '!rounded-2xl'
];

const getButtonClasses = (choice, isSelected) => {
  return clsx(
    BASE_BUTTON_CLASSES,
    choice.borderColor,
    choice.textColor,
    `shadow-[0px_6px_0px_0px_${COLORS.DEFAULT_SHADOW}]`,
    {
      [`!border-[${COLORS.DEFAULT_BORDER}]`]: isSelected,
      [`bg-[${COLORS.DEFAULT_BACKGROUND}]`]: isSelected,
      [`!shadow-[0px_6px_0px_0px_${COLORS.SELECTED_SHADOW}]`]: isSelected
    }
  );
};

const getTextClasses = (isSelected) => {
  return clsx(
    'text-[16px]',
    'font-semibold',
    {
      [`text-[${COLORS.TEXT_COLOR}]`]: !isSelected
    }
  );
};

const getIconClasses = () => {
  return clsx(
    'text-2xl',
    `text-[${COLORS.ICON_COLOR}]`
  );
};

const ChoiceButton = ({ choice, isSelected, onClick }) => {
  const Icon = choice.icon;

  return (
    <button
      type="button"
      className={getButtonClasses(choice, isSelected)}
      onClick={onClick}
    >
      <span className={getTextClasses(isSelected)}>
        {choice.label}
      </span>
      <Icon className={getIconClasses()} />
    </button>
  );
};

export default ChoiceButton;